/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { CTAs, SaveButton, DiscardButton } from '@insticator/insticator-ui'; // iui-material
// utils
import { isContentValid } from 'utils/embedcontentvalidation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedupdatecta/embedupdatecta_styles';



/* ========== ~~~~~~~~~~ EMBED UPDATE CTA ~~~~~~~~~~ ========== */
class EmbedUpdateCTA extends Component {
    handleClick = e => {
        if(isContentValid(this.props.selectedContent)) {
            if(this.props.uploadingCustomImage) {
                this.props.sendErrorMessage('You can save once your image has been uploaded successfully');
                return null;
            }
            this.props.handleSaveEmbed();
        }else{
            this.props.invalidateSelectedContent();
            this.props.sendErrorMessage('There are required fields you must fill out before continuing. Please check if all the options are unique.');
        }
    };
    render() {
        return (
            <div className={`embedupdatecta ${this.props.classes.embedupdatecta}`}>
                <CTAs>
                    {this.props.changeDetected ? <DiscardButton discardChanges={this.props.discardChanges} disabled={this.props.isSavingData} /> : null}
                    <SaveButton
                        handleSave={this.handleClick}
                        savingData={this.props.isSavingData}
                        buttonText={this.props.changeDetected ? null : 'Saved'}
                        disabled={!this.props.changeDetected || this.props.isSavingData}
                    />
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedUpdateCTA);
